import {
  addTemplateComponent,
  deleteTemplateComponent,
  getTemplateComponents,
  updateTemplateComponent,
} from "../../../SalaryApi";
import { buildTemplateComponentLinkPayload } from "./buildTemplateComponentLinkPayload";

function errorText(err) {
  const detail = err?.detail ?? err?.response?.data?.detail ?? err?.message ?? err;
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) {
    return detail.map((item) => item?.msg || item?.message || "").join(" ");
  }
  if (detail && typeof detail === "object") return detail.msg || detail.message || "";
  return String(detail || "");
}

function isMissingFormulaError(err) {
  return /stored formula|define formula on the salary component/i.test(errorText(err));
}

function withoutTemplateFormula(payload) {
  return {
    ...payload,
    formula: null,
  };
}

async function saveTemplateLink(payload, existingId) {
  const write = (body) => (
    existingId
      ? updateTemplateComponent(existingId, {
          sequence: body.sequence,
          calculation_source: body.calculation_source,
          reference: body.reference,
          formula: null,
        })
      : addTemplateComponent(body)
  );
  try {
    await write(payload);
  } catch (err) {
    if (!isMissingFormulaError(err)) throw err;
    await write(withoutTemplateFormula(payload));
  }
}

/**
 * Update mappings on an existing template (add new, remove deselected).
 */
export async function resyncPipelineTemplateComponents(templateId, selectedIds = [], comps = []) {
  if (!templateId) throw new Error("Template ID is required.");
  const selectedSet = new Set((selectedIds || []).map(String));
  const existing = await getTemplateComponents(templateId);
  const rows = Array.isArray(existing) ? existing : [];

  for (const row of rows) {
    const cid = String(row.component_id || "");
    const stcId = row.stc_id || row.id;
    if (!stcId) continue;
    if (!selectedSet.has(cid)) {
      // eslint-disable-next-line no-await-in-loop
      await deleteTemplateComponent(stcId);
    }
  }

  const existingById = new Map(rows.map((r) => [String(r.component_id), r]));
  let seq = 1;
  for (const id of selectedSet) {
    const comp = (comps || []).find((c) => String(c.component_id) === String(id));
    if (!comp) {
      seq += 1;
      continue;
    }
    const payload = buildTemplateComponentLinkPayload(templateId, comp, seq);
    const current = existingById.get(String(id));
    const existingId = current?.stc_id || current?.id || null;
    // eslint-disable-next-line no-await-in-loop
    await saveTemplateLink(payload, existingId);
    seq += 1;
  }

  return getTemplateComponents(templateId);
}

/**
 * Create template component links for a new template (final submit).
 */
export async function syncPipelineTemplateComponents(templateId, selectedIds = [], comps = []) {
  if (!templateId) throw new Error("Template ID is required.");
  const selectedSet = new Set((selectedIds || []).map(String));
  let seq = 1;

  for (const id of selectedSet) {
    const comp = (comps || []).find((c) => String(c.component_id) === String(id));
    if (!comp) continue;
    const payload = buildTemplateComponentLinkPayload(templateId, comp, seq);
    // eslint-disable-next-line no-await-in-loop
    await saveTemplateLink(payload, null);
    seq += 1;
  }

  return getTemplateComponents(templateId);
}
